"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toBase64URL;

function toBase64URL(base64String) {
  return base64String.replace(/\+/g, '%2B').replace(/\//g, '%2F').replace(/=/g, '%3D');
}